var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4059 18.1537L20.3369 16.2227",
    stroke: "#9283BD",
    strokeWidth: 0.941526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.5597C25 11.5597 25.0145 14.2527 23.3344 15.8892C21.6533 17.5279 20.3369 16.2216 20.3369 16.2216C20.3369 16.2216 19.0318 14.9064 20.6705 13.2241C22.307 11.5441 25 11.5586 25 11.5586V11.5597Z",
    stroke: "#71C9CD",
    strokeWidth: 0.941526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2798 11.5605V22.1204",
    stroke: "#4B3884",
    strokeWidth: 0.847819,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.359 22.1191H22.5994V26.9194C22.5994 27.9802 21.7393 28.8392 20.6795 28.8392H16.359",
    stroke: "#4B3884",
    strokeWidth: 0.847819,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4797 11.54H1.96049C1.43003 11.54 1 11.9701 1 12.5005V28.8199C1 29.3504 1.43003 29.7804 1.96049 29.7804H13.4797C14.0101 29.7804 14.4402 29.3504 14.4402 28.8199V12.5005C14.4402 11.9701 14.0101 11.54 13.4797 11.54Z",
    stroke: "#4B3884",
    strokeWidth: 0.847819,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7066 13.46H2.73352V16.3403H12.7066V13.46Z",
    stroke: "#9283BD",
    strokeWidth: 0.941526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67951 18.2598H6.75964V20.1796H8.67951V18.2598Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5192 18.2598H10.5994V20.1796H12.5192V18.2598Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83979 18.2598H2.91992V20.1796H4.83979V18.2598Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67951 22.1006H6.75964V24.0205H8.67951V22.1006Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5192 22.1006H10.5994V24.0205H12.5192V22.1006Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83979 22.1006H2.91992V24.0205H4.83979V22.1006Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67951 25.9404H6.75964V27.8603H8.67951V25.9404Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5192 25.9404H10.5994V27.8603H12.5192V25.9404Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83979 25.9404H2.91992V27.8603H4.83979V25.9404Z",
    stroke: "#9283BD",
    strokeWidth: 0.587896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8397 7.48088C16.8397 8.14352 17.4845 8.68122 18.2799 8.68122C19.0753 8.68122 19.7201 8.14352 19.7201 7.48088C19.7201 6.81825 19.0753 6.28055 18.2799 6.28055C17.4845 6.28055 16.8397 5.74285 16.8397 5.08022C16.8397 4.41758 17.4845 3.87988 18.2799 3.87988C19.0753 3.87988 19.7201 4.41758 19.7201 5.08022",
    stroke: "#71C9CD",
    strokeWidth: 0.96049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2799 2.91992V3.88041",
    stroke: "#71C9CD",
    strokeWidth: 0.96049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2799 9.64018V8.67969",
    stroke: "#71C9CD",
    strokeWidth: 0.96049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2799 11.5598C21.1959 11.5598 23.5598 9.19592 23.5598 6.27991C23.5598 3.36389 21.1959 1 18.2799 1C15.3639 1 13 3.36389 13 6.27991C13 9.19592 15.3639 11.5598 18.2799 11.5598Z",
    stroke: "#2BBCB0",
    strokeWidth: 0.96049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.caa8ce00b7440c4db733d07b1b0d6f7d.svg";
export { ForwardRef as ReactComponent };